import React from "react";
import s from "./KumoHero.module.scss";

const KumoHero = ({ title, colorText, text, backgroundImage, image, content, jumplinks, ...props }) => {
    console.log({jumplinks});
    // console.log(props);
    return <section className={`kumo-hero ${s.root}`}>
        <div className={s.container}>
            <h1 className={s.title} dangerouslySetInnerHTML={{ __html: title }} />
            <div className={s.content} style={{ backgroundImage: `url("${backgroundImage.url}?w=1440")` }}>
                <img className={s.image} src={`${image.url}?w=900`} alt={image.alt} />
                {!!jumplinks?.length && <div className={s.textContainer}>
                    <div className={s.textWrapper}>
                        {jumplinks.map((link, i) => <a 
                            key={i} 
                            href={link?.fields?.link?.href} 
                            target={link?.fields?.link?.target}
                        >
                                <span className={i == 0 ? s.colorText : s.text}>{link?.fields?.link?.text}</span>
                        </a>)}
                    </div>
                </div>}
            </div>
            <div id="download-app" className={s.description} dangerouslySetInnerHTML={{ __html: content }} />
        </div>
    </section>;
};

export default KumoHero;